import { useEffect, useState, useRef } from "react";
import getMappingManager, { sanitizeMapping } from "./mappingManager";
import MappingRow from "./MappingRow";
import TranslationsContext from './TranslationsContext';
import {__, TranslateHTML} from "./Translate";
import Sortable from 'sortablejs';

function App({ mappingInit, i18n, fields, defaultMappingOptions, isOptionAvailable, config, localValidation }) {
	const inputRef = useRef(null);
	const [ mapping, setMapping ] = useState(sanitizeMapping(mappingInit, fields));
	const mappingManager = getMappingManager({ mapping, setMapping, fields, defaultMappingOptions, isOptionAvailable, config });
	const { addMappingRow, moveMappingRow } = mappingManager;
	const addMappingRowHandler = () => {
		addMappingRow();
	};

	useEffect(() => {
		const event = new CustomEvent('airwpsync/mapping-updated', { detail: mapping } );
		document.dispatchEvent(event);

		const sortableInstance = Sortable.create(inputRef.current, {
			handle: '.btn-sort',
			onUpdate: (evt) => {
				moveMappingRow(evt.oldIndex, evt.newIndex);
			}
		});

		return () => {
			sortableInstance.destroy();
		};
	}, [ mapping, moveMappingRow ]);

	return <TranslationsContext.Provider value={ i18n }>
		<table className="form-table">
			<thead>
				<tr>
					<th>
						<span>{ __('Airtable Field', 'air-wp-sync') }</span>
						<span className="airwpsync-required" aria-hidden="true"> *</span>
						<span className="screen-reader-text">{ __(' (required)', 'air-wp-sync') }</span>
					</th>
					<th>
						<span>{ __('Import As', 'air-wp-sync') }</span>
						<span className="airwpsync-required" aria-hidden="true"> *</span>
						<span className="screen-reader-text">{ __(' (required)', 'air-wp-sync') }</span>
					</th>
					<th className="col-actions"></th>
				</tr>
			</thead>
			<tbody key="metabox-mapping-body" ref={ inputRef }>
				{
					mapping.length > 0
						? mapping.map((mappingRow, index) => {
							return <MappingRow key={ mappingRow.key } index={ index } airtableField={ mappingRow.airtable } wordPressField={ mappingRow.wordpress } fieldOptions={ mappingRow.options } mappingManager={ mappingManager } />
						})
						: <tr>
							<td colSpan="3">
								<TranslateHTML
									className="no-mapping"
									string={ (__) => __('Click the <strong>+ Add Field</strong> button to create your first field.', 'air-wp-sync') }
									allowedHTMLTags={[ 'strong' ]}
								/>
							</td>
						</tr>
				}
			</tbody>
			<tfoot key="metabox-mapping-footer">
				<tr>
					<td colSpan="2">
						{
							(localValidation.errorMessages ?? []).map(function (message) {
								return <p className="airwpsync-validation-message">{ message }</p>;
							})
						}
					</td>
					<td>
						<button type="button" className="button button-primary button-large" onClick={ addMappingRowHandler }>
							<span>{ __('+ Add Field', 'air-wp-sync') }</span>
						</button>
					</td>
				</tr>
			</tfoot>
		</table>
	</TranslationsContext.Provider>;
}

export default App;
